<div class="background-signing"></div>

<div class="overlay">

  <div *ngIf="signin" class="login-card">

    <div class="login-left">
      <div class="login-area">
        <img
          *ngIf="dataManager.brandingReady && dataManager.loginlogo"
          [src]="dataManager.loginlogo"
          alt="Logo"
          class="login-logo"
        />
      </div>

      <!-- <div class="powered-by-logo">
        <img src="assets/images/powered_by_payarc.svg" alt="Powered by Payarc" />
      </div> -->

    </div>

    <div class="login-right">

      <ng-container *ngIf="topErrorMessage">
        <div *ngFor="let obj of keys1">
          <div *ngFor="let value of obj">
            <p class="error">{{ value }}</p>
          </div>
        </div>
      </ng-container>

      <div class="error mb-2" *ngIf="!topErrorMessage">
        {{ errorMsg }}
      </div>

      <p class="heading2">Sign in to {{ dataManager.orgName ? dataManager.orgName : 'Merchant Dashboard' }}</p>

      <!-- <span
        class="partner-link"
        *ngIf="dataManager.brandingReady !== null && dataManager.partnerhubUrl !== null"
      > -->
      <span class="partner-link" *ngIf="dataManager.partnerhubUrl">
        <b>Partners</b>
        <a
          [href]="dataManager.partnerhubUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          Click here
        </a>
      </span>

      <div class="form-group">
        <!-- <label class="l_label" for="username">Username</label> -->
        <input
          class="form-control"
          type="text"
          id="username"
          placeholder="Username"
          [(ngModel)]="username"
          (keydown)="onKeydown($event)"
          required
        />
      </div>

      <div class="form-group">
        <div class="password-row">
          <!-- <label class="l_label" for="password">Password</label> -->
          <!-- <a class="forgot-link" (click)="redirectToForgotPassword()">Forgot?</a> -->
        </div>
        <input
          class="form-control"
          type="password"
          id="password"
          placeholder="Password"
          [(ngModel)]="password"
          (keydown)="onKeydown($event)"
          required
        />
      </div>

      <div class="form-group" *ngIf="tw0fa">
        <label class="l_label">2FA Code</label>
        <input
          class="form-control"
          maxlength="6"
          [(ngModel)]="tw0faCode"
          required
        />
        <div class="alert-success">
          A verification code has been sent to your email.
        </div>
      </div>

      <div class="form-group" *ngIf="app2fa">
        <label class="l_label">2FA Code</label>
        <input
          class="form-control"
          maxlength="6"
          [(ngModel)]="tw0faCode"
          required
        />
        <div class="alert-success">
          Please enter the code from your 2FA app.
        </div>
      </div>

      <button
        class="bt_signin"
        [disabled]="loadFlag"
        (click)="signIn()"
      >
        Sign In
        <i *ngIf="loadFlag" class="fa fa-spinner fa-pulse ml-2"></i>
      </button>

      <div class="login-options">
        <!-- <label class="remember-me">
          <input type="checkbox" [(ngModel)]="rememberMe" />
          <span>Remember me</span>
        </label> -->
        <div></div>
        <a class="forgot-link" (click)="redirectToForgotPassword()">
          Forgot password?
        </a>
      </div>

      <div class="privacy-links">
        <a href="https://www.payarc.com/privacy-policy" target="_blank">Privacy Policy</a>
        <span>|</span>
        <a href="https://www.payarc.com/company/terms-and-conditions" target="_blank">Terms & Conditions</a>
      </div>

    </div>

  </div>

</div>
